
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

import Home from "./pages/Home";
import Admin from "./pages/Admin";
import AdminNAVPage from "./pages/AdminNAVPage";
import AdminWhatsNewPage from "./pages/AdminWhatsNewPage";
import AccessMasterPage from "./pages/AccessMasterPage";
import AdminPostsPage from "./pages/AdminPostsPage";
import LoginPopup from "./components/LoginPopup";
import CommitmentPageForDoerAbsent from "./pages/CommitmentPageForDoerAbsent";
import SalesDashboard from "./pages/SalesDashboard";
import MailerControlPage from "./pages/MailerControlPage";

axios.defaults.withCredentials = true;

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

const fetchUser = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_NAV_API}/auth/me`,
      {
        validateStatus: () => true   // 🔥 KEY FIX
      }
    );

    // ✅ handle 401 silently
    if (res.status === 401) {
      setUser(null);
      return;
    }

    setUser(res.data.user);

  } catch (err) {
    console.error("Auth error:", err);
    setUser(null);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchUser();
  }, []);

  if (loading) return <div>Loading...</div>;
  // console.log("USER DATA:", user);

  // 🔐 NOT LOGGED IN → SHOW POPUP
  if (!user) {
    return <LoginPopup onLogin={fetchUser} />;
  }
function AdminRoute({ user, children }) {
  if (!user?.roles?.includes("ADMIN")) {
    return <div style={{ padding: 20 }}>🚫 Not Authorized</div>;
  }
  return children;
}
  // ✅ LOGGED IN → SHOW APP
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Home user={user} />} />
        <Route path="/error-correction" element={<Home user={user} />} />
        <Route path="/sales-dashboard" element={<SalesDashboard />} />
        <Route
           path="/commitment"
           element={<CommitmentPageForDoerAbsent user={user} />}
         />

        {/* <Route path="/admin" element={<AdminNAVPage />}> */}
          <Route
             path="/admin"
             element={
               <AdminRoute user={user}>
                 <AdminNAVPage />
               </AdminRoute>
             }
           >
          <Route index element={<Navigate to="/admin/nav" replace />} />
          <Route path="nav" element={<Admin />} />
          <Route path="whatsnew" element={<AdminWhatsNewPage />} />
          <Route path="posts" element={<AdminPostsPage />} />
          <Route path="access-master" element={<AccessMasterPage />} />
          <Route path="mailer" element={<MailerControlPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}